<template>
  <div style="max-height: 500px" class="overflow-y-auto">
    <el-alert title="支付审批可以添加多名审批人，但最后一位必须是企业管理员" type="success"> </el-alert>
    <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="申请人：" prop="name">
        {{ userName }}
      </el-form-item>
      <el-form-item label="支付金额(元)：" prop="money"> {{ totalAmount }}</el-form-item>
      <el-form-item label="审批人：" prop="peo1">
        <dygc-user is-order :value="disableList" @input="getInputList" ref="dygcUser" />
        <!-- <div style="max-height: 600px" class="overflow-y-auto">
          <el-tree
              ref="userTree"
              :data="auditList"
              :props="props"
              node-key="id"
              show-checkbox
              @check="handleCheckChange"
              empty-text="暂无角色"
          />
        </div> -->
        <ul class="audit-groups">
          <li class="audit-item" v-for="(user, index) in checkedAuditUsers" :key="user.id">
            <el-popover placement="bottom" trigger="click">
              <template v-slot:default>
                <div class="text-center">
                  <el-button @click="onClickDelAuditUser(index)">删除</el-button>
                </div>
              </template>
              <el-button type="text" slot="reference"
                ><span>{{ user.name }}</span></el-button
              >
            </el-popover>
          </li>
        </ul>
      </el-form-item>
      <el-form-item required label="终审管理员：" prop="finalManager">
        <el-select v-model="ruleForm.finalManager">
          <el-option v-for="manager in businessManager" :key="manager.id" :value="manager.id" :label="manager.name" />
        </el-select>
        <p>{{ finalManagerName }}</p>
      </el-form-item>
      <el-form-item required :show-message="false" label="备注：" prop="desc">
        <el-input placeholder="请输入" type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-row class="btnGroup">
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">提交</el-button>
          <el-button @click="resetForm('ruleForm')" size="small">取消</el-button>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getDygcManage } from '@/api/wenjuan/user'
import { submitApproval } from '@/api/pay/approval'
import { initDygcUser, getDygcAllUser, adoptKeyToUserId, getCurrentTreeUserNode } from '@/assets/js/dygc-util'
import DygcUser from '@/components/dygc-user/DygcUser'

export default {
  components: { DygcUser },
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      companyUser: null,
      businessManager: [], // 管理员列表
      auditList: [],
      disableList: [],
      ruleForm: {
        finalManager: '', // 终审管理员id
        name: '',
        region: '',
        peo1: '',
        peo2: '',
        desc: ''
      },
      mineStatus: '',
      visSelectVal: '',
      selectVal: '',
      selectVal1: '',
      mineStatusValue: [],
      data: [],
      props: {
        label: 'name',
        children: 'children'
      },
      checkedKeys: [], // 选择的审核员
      checkedAuditUsers: []
    }
  },
  created() {
    this.initApprovalUser()
  },
  computed: {
    finalManagerName() {
      let result = this.businessManager.find(manage => manage.id === this.ruleForm.finalManager)
      if (!result) return ''
      return result.name
    },
    totalAmount() {
      // 支付金额
      return parseFloat(this.paymentInfo.totalAmount).toFixed(2)
    },
    userName() {
      let userInfo = this.userInfo
      return (userInfo.username ? userInfo.username + '-' : '') + userInfo.nickname || ''
    },
    ...mapGetters(['userInfo'])
  },
  methods: {
    getInputList(value) {
      this.disableList = value
      this.checkedAuditUsers = value
    },
    onClickDelAuditUser(index) {
      this.checkedAuditUsers.splice(index, 1)
      this.$refs.dygcUser.$refs.userTree.setCheckedKeys(
        this.checkedAuditUsers.map(item => item.id),
        false
      )
    },
    // handleCheckChange(item, data) {
    //   // this.checkedAuditUsers = adoptKeyToUserId(data.checkedKeys)
    //   // return
    //   let checkedAuditUsers = this.checkedAuditUsers.slice()

    //   if (item.flag) {
    //     // 如果为 true 说明则是企业员工 直接追加到 最后
    //     checkedAuditUsers.push(item)
    //   } else {
    //     // 否则 则是企业部门
    //     let users = adoptKeyToUserId(getCurrentTreeUserNode(item, data.checkedKeys))
    //     users.forEach(user => {
    //       if (!checkedAuditUsers.some(u => u.id === user.id)) {
    //         checkedAuditUsers.push(user)
    //       }
    //     })
    //   }
    //   // 过滤掉没有选中到用户
    //   checkedAuditUsers = checkedAuditUsers.filter(user => data.checkedKeys.includes(user.id))
    //   this.checkedAuditUsers = checkedAuditUsers
    //   /* if (!data.checkedKeys.length) {
    //      this.checkedAuditUsers = []
    //      return
    //    }
    //    this.checkedAuditUsers = this.checkedAuditUsers.filter(user => {
    //      return data.checkedKeys.includes(user.id)
    //    })
    //    let arr = []
    //    if (item.flag) {
    //      arr = [item]
    //    } else {
    //      arr = adoptKeyToUserId(getCurrentTreeUserNode(item, data.checkedKeys))
    //    }
    //    arr.forEach(item => {
    //      if (!this.checkedAuditUsers.some(i => i.id === item.id)) {
    //        this.checkedAuditUsers.push(item)
    //      } else {
    //        let idx = this.checkedAuditUsers.findIndex(i => i.id === item.id)
    //        this.checkedAuditUsers.splice(idx, 1)
    //      }
    //    })*/
    // },
    initApprovalUser() {
      getDygcAllUser().then(res => {
        this.companyUser = res
        this.auditList = initDygcUser(this.companyUser)
      })
      getDygcManage().then(res => {
        this.businessManager = res.data.data
      })
    },
    submitForm(formName) {
      let ruleForm = this.$refs.ruleForm
      if (!this.ruleForm.finalManager) {
        this.$message.warning('提交失败，未选择终审管理员')
        return
      }
      if (!this.ruleForm.desc) {
        this.$message.warning('提交失败，未填写备注')
        return
      }
      let auditors = this.checkedAuditUsers.map(item => ({ id: item.id }))
      if (auditors.some(({ id }) => id === this.ruleForm.finalManager)) {
        this.$message.warning('审核员不能包含终审管理员')
        return
      }
      let data = {
        id: this.paymentInfo.awardId,
        auditors,
        finalAuditor: { id: this.ruleForm.finalManager },
        remark: this.ruleForm.desc
      }

      submitApproval(data)
        .then(res => {
          this.$message.success('已提交审批，审批通过后金额会自动支付')
          this.$emit('submit')
        })
        .catch(err => {
          this.$message.error('系统错误')
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/envelopes.scss';

.show-head,
.show-body {
  @apply w-full flex justify-between;
  span {
    @apply flex-1 leading-9 text-center;
  }
}

.settlement {
  .show-sum {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
<style lang="scss" scoped>
.audit-groups {
  .audit-item {
    @apply inline-block;
    margin-right: 10px;

    &::after {
      content: ' ';
      display: inline-block;
      width: 8px;
      height: 8px;
      border: 1px solid #000;
      border-left: none;
      border-bottom: none;
      transform: rotate(45deg);
    }

    &:last-child {
      &::after {
        content: '';
        width: 0;
        height: 0;
      }
    }
  }
}

.demo-ruleForm {
  width: 500px;
  margin: auto;

  .btnGroup {
    margin-left: 60px;
    margin-bottom: 30px;
  }
}
</style>
